import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { listSettlements } from "../../api/settlements";
import { formatCurrency } from "./reportFormat";
import { S } from "./settlementLabels";

// قائمة التسويات المحفوظة (نهاية الخدمة) للشركة.
export const SettlementList = ({ refreshKey }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const L = S[lang === "en" ? "en" : "ar"];
  const [items, setItems] = useState([]);
  useEffect(() => { listSettlements().then(setItems).catch(() => setItems([])); }, [refreshKey]);
  return (
    <NeuCard data-testid="settlement-list">
      <p className="label-xs">{L.saved}</p>
      {items.length ? (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-start text-xs">
            <thead>
              <tr className="bg-primary/10">
                {L.listCols.map((h) => (
                  <th key={h} className="px-2 py-2 text-start text-[10px] font-bold text-primary">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} className="border-b border-border/30" data-testid={`settlement-row-${s.id}`}>
                  <td className="px-2 py-2 font-bold">{s.user_name}</td>
                  <td className="px-2 py-2">{s.branch_name}</td>
                  <td className="px-2 py-2">{L.exitTypes[s.exit_type] || L.reasons[s.reason] || s.reason}</td>
                  <td className="px-2 py-2 font-mono">{s.last_working_day}</td>
                  <td className="px-2 py-2 font-mono">{s.years_of_service}</td>
                  <td className="px-2 py-2 font-mono font-black text-primary">
                    {formatCurrency(s.net_amount, s.currency)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="settlement-list-empty">{L.empty}</p>
      )}
    </NeuCard>
  );
};
